<div class="main">
  <div>
    <span
      *ngIf="groupBac.ownerId === (myRadioId$ | async); else elseradio"
      class="radio-title"
      translate
      >MEDIA.BACS.TITLE_MINE</span
    >
  </div>
  <ng-template #elseradio>
    <span class="radio-title">Radio number {{ groupBac.ownerId }}</span>
  </ng-template>
  <div class="bac-content">
    <ng-container *ngFor="let bac of groupBac.boxes; let first = first">
      <rk-library-root-bac
        [radioId]="radioId"
        [bac]="bac"
        [disableBar]="first"
        [planDesc]="planDesc$ | async"
      ></rk-library-root-bac>
    </ng-container>
  </div>
  <div class="trash-content">
    <rk-library-root-trash
      (click)="trackClickTrash()"
      [radioId]="radioId"
    ></rk-library-root-trash>
  </div>
</div>

<!--
  <div class="bacs-header" translate>MEDIA.BACS.TITLE_MINE</div>

  <div class="bacs-listings">
    <ul class="root-bac">
      <ng-container *ngFor="let bac of bacs$ | async; let first = first;">

        <rk-library-root-bac
          [bac]="bac"
          [disableBar]="first"
        ></rk-library-root-bac>
        <div
          [@slideInOutBlock] *ngIf="bac.children && bac.children.length > 0 && actualUrlBac === bac.url"
        >
          <rk-library-sbac
            [bacs]="bac.children"
          ></rk-library-sbac>
        </div>
      </ng-container>
    </ul>
    <button mat-button (click)="sidenav.toggle()">sidenav.toggle()</button>
  </div>
-->
